<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('')"
        centered
        @hidden="cancelar"
        id="modal-show-evento"
    >
        TESTE {{ evento }}
    </b-modal>
</template>
<script>
export default {
    name: "Add",
    props: ["evento"],
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$bvModal.hide("modal-show-evento");
        }
    }
};
</script>
<style></style>
